/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import styled from 'styled-components';
import {
    StackView,
    STACK_DIRECTION,
    STACK_GAP,
    View,
    SIZE_M,
    SIZE_L,
    SIZE_XL,
    Text, VIEW_CONTENT_MOD, TEXT_SIZE, STACK_ALIGN, STACK_DISTRIBUTION,
} from '@veeam/components';

const WrapperContent = styled(View)`
    background-color: #fff;
    border-radius: ${SIZE_M};
    padding: ${SIZE_L};
`;

const OrText = styled(Text)`
    line-height: ${SIZE_XL};
    color: ${({ theme }) => theme.colorLoginTitle};
`;

export interface BaseFormProps {
    width?: string;
    children: React.ReactElement | React.ReactElement[];
    alternativeButton?: React.ReactElement;
    beforeBtnText?: string;
}

export const BaseForm: React.FC<BaseFormProps> = ({ width, children, alternativeButton, beforeBtnText = 'Or' }) => (
    <StackView
        align={STACK_ALIGN.center}
        distribution={STACK_DISTRIBUTION.start}
        direction={STACK_DIRECTION.column}
        gap={STACK_GAP.s}
        size={{ width }}
    >
        <WrapperContent contentMod={VIEW_CONTENT_MOD.fill}>{children}</WrapperContent>

        {alternativeButton && (
            <StackView
                align={STACK_ALIGN.center}
                direction={STACK_DIRECTION.column}
                gap={STACK_GAP.s}
            >
                <OrText truncate size={TEXT_SIZE.xl}>
                    {beforeBtnText}
                </OrText>

                {alternativeButton}
            </StackView>
        )}
    </StackView>
);
